import cx from 'classnames'

import { spacingStyles } from '../../libs/spacingStyles'

export const inputWrapperStyles = ({
  hasRightColumn,
  isTableCell,
  hasCustomWidth,
}: {
  hasRightColumn?: boolean
  isTableCell?: boolean
  hasCustomWidth?: boolean
} = {}) => {
  const useDefaultWidth = !hasCustomWidth && !isTableCell
  const oneColumnWidth = cx(useDefaultWidth && 'w-(--amaze-inputWrapper-width)')
  const twoColumnWidth = cx(
    useDefaultWidth && 'w-(--amaze-inputWrapper-width-two-column)',
  )
  return cx(
    'inline-grid items-end',
    'gap-y-0', // since spacingStyles adds a default gap, we need to reset the vertical gap to 0 to ensure the label is properly aligned with the input
    spacingStyles({ gap: 'normal' }),
    isTableCell
      ? cx(
          hasRightColumn
            ? 'grid-cols-[fit-content(100%)_fit-content(100%)]'
            : '',
        )
      : cx(
          '*:min-w-0', // Ensure children don't overflow the wrapper, allowing for proper truncation and wrapping of text
          'max-w-full', // Ensure the wrapper doesn't exceed the width of its container if we are in a tight spot
          hasRightColumn
            ? `grid-cols-2 ${twoColumnWidth}`
            : `grid-cols-1 ${oneColumnWidth}`,
        ),
  )
}

export const inputWrapperMinWidthStyles = cx(
  'min-w-(--amaze-inputWrapper-width-two-column)',
)

export const inputMinWidthStyles = cx('min-w-(--amaze-inputWrapper-width)')
